import { shallowRef, ref } from 'vue'
import { useTemplate } from '../../../hooks/index'
import { setValueByPath, setValueByPathToVue } from '../../../utils/index'
import { get } from '../../../utils/index'

/**
 * 查询表单处理
 * @param {查询条件是否设置默认事件（如光标在输入框时点击回车触发查询等）} queryFormEvent
 * @returns
 */
export function useCriteriaQueryDrawer(url, code, colum, defaultParameter) {
  const { getTemplateData, compileData } = useTemplate()
  const queryForm = shallowRef({ items: [] })
  const queryData = ref({})

  //当key存在时修改queryData对应key的值为data，key不存在时修改queryData为data
  const updateQueryData = (data) => {
    if (!queryForm.value?.items || queryForm.value?.items?.length <= 0) return
    queryForm.value.items.forEach((element) => {
      setValueByPathToVue(queryData.value, element.property, data[element.property])
    })
  }

  //设置默认值
  const setDefaultQuery = (data) => {
    const templateData = getTemplateData()
    queryData.value = queryForm.value.items.reduce((pre, cur) => {
      if (cur.defaultValue) {
        setValueByPath(pre, cur.property, compileData(cur.defaultValue, templateData))
      }
      return pre
    }, {})
    queryData.value = Object.assign({}, queryData.value, data)
  }

  // 设置高级查询条件
  const setQueryForm = (resData) => {
    queryForm.value = {
      code: resData.criteria.code,
      id: resData.criteria.id,
      form: {
        property: {
          formGroup: false,
          colNum: colum,
        },
      },
      items: resData.items,
    }
  }

  const initParameter = async () => {
    if (defaultParameter) {
      return defaultParameter
    }
  }

  const getCriteria = async () => {
    const [res] = await get(`${url}${code}`)
    if (res) {
      const defaultParameter = await initParameter()
      return [res.data, defaultParameter]
    } else {
      return Promise.reject({ msg: `【${url}${code}】请求错误` })
    }
  }

  return {
    getCriteria,
    queryForm,
    queryData,
    updateQueryData,
    setQueryForm,
    setDefaultQuery,
  }
}
